import React from "react";
import { useNavigate } from "react-router-dom";

export default function ManageVideos() {
  const navigate = useNavigate();

  const units = [
    { unit: 1, title: "Unit 1", episodes: 14 },
    { unit: 2, title: "Unit 2", episodes: 3 },
    { unit: 3, title: "Unit 3", episodes: 2 },
    { unit: 4, title: "Unit 4", episodes: 2 }
  ];

  return (
    <div style={{ background: "#ffffff", minHeight: "calc(100vh - 70px)", padding: "3rem 2rem" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div style={{ marginBottom: "3rem", paddingBottom: "1.5rem", borderBottom: "2px solid #e8e8e8" }}>
          <h1 style={{ fontSize: "2.5rem", fontWeight: 700, color: "#1a1a1a", letterSpacing: "-1px", margin: "0" }}>
            <i className="fas fa-video" style={{ marginRight: "1rem" }}></i>
            Manage Course Videos
          </h1>
          <p style={{ fontSize: "1rem", color: "#666", margin: "0.5rem 0 0 0" }}>
            Select a unit to manage its videos
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "1.5rem" }}>
          {units.map((unit) => (
            <div
              key={unit.unit}
              onClick={() => navigate(`/manage-videos/unit/${unit.unit}`)}
              style={{
                background: "#ffffff",
                borderRadius: "12px",
                padding: "2.5rem",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                border: "1px solid #e8e8e8",
                color: "#1a1a1a"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow = "0 12px 24px rgba(0, 0, 0, 0.12)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.08)";
              }}
            >
              <h2 style={{ fontSize: "1.75rem", margin: "0 0 1rem 0", fontWeight: 700, color: "#1a1a1a" }}>
                {unit.title}
              </h2>
              <p style={{ fontSize: "1rem", margin: "0 0 1.5rem 0", color: "#666" }}>
                {unit.episodes} episodes
              </p>
              <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontSize: "0.95rem", color: "#667eea" }}>
                <span>Manage Videos</span>
                <i className="fas fa-arrow-right" style={{ marginLeft: "0.5rem" }}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}